export default __webpack_public_path__ + "static/media/Income_Statement.60ea9e7a.svg";